import { memo, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import { getData } from '../../../../../assets/scripts/GeneralFunctions'
import { title_class } from '../../../../../functions/stateList'
import { setPageName } from '../../../../../redux'
import AddMoreButton from '../../../../buttons/AddMoreButton'
import DefaultButton from '../../../../buttons/DefaultButton'
import HistoryButton from '../../../../buttons/HistoryButton'
import CarChangesModal from '../../../../modal/CarChangesModal'
import CarInfoTable from '../../../../tabels/CarInfoTable'
import CarInfoUser from '../../../../tabels/CarInfoUser'
import ServiceDateSection from '../../service/child/ServiceDateSection'
import CarCode from './CarCode'

function CarInfo() {
  const [car, setCar] = useState({})
  const [customerTypes, setCustomerTypes] = useState({})
  const [lastVisit, setLastVisit] = useState({})
  const [car_models, setCarModels] = useState([])
  const [carChanges, setCarChanges] = useState([])
  const [showModal, setShowModal] = useState(false)

  let { car_code } = useParams()
  const dispatch = useDispatch()

  useEffect(() => {
    async function fetchData() {
      dispatch(setPageName('cars'))
      let api_result = await getData(`admin/cars/${car_code}`, 'get', {}, true)
      if (api_result) {
        if (api_result?.status === 200) {
          let result_data = api_result?.data
          let visits = result_data?.car?.['visits']
          setCar(result_data?.car)
          setCustomerTypes(result_data?.customer_types)
          setCarModels(result_data?.['car_models'])
          setLastVisit(visits[visits?.length - 1])
          setCarChanges(result_data?.car_changes)
        }
      }
    }

    fetchData()
  }, [])

  return (
    <>
      <CarCode title={'کد خودرو'} code={car_code} />
      <div className="flex flex-col mb-16">
        <h2 className={title_class}>اطلاعات خودرو</h2>
        <CarInfoTable car_models={car_models} car={car} setCar={setCar} />
      </div>

      <div className="flex flex-col mb-16">
        <h2 className={title_class}>اطلاعات فردی</h2>
        <CarInfoUser
          car={car}
          customer_types={customerTypes}
          customer={car?.customer}
          setCar={setCar}
        />
      </div>

      <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-6">
        <h2 className={title_class}>آخرین خدمات اجرا شده</h2>
        <div className="flex items-center gap-x-6">
          <AddMoreButton carId={car?.id} link={'service'} title={'ثبت سرویس جدید'} icon={'add'} />
          {car?.['visits']?.length > 1 && (
            <HistoryButton link={`cars/${car?.code}/service`} title={'تاریخچه خدمات'} />
          )}
          {carChanges?.length > 1 && (
            <DefaultButton clickHandler={() => setShowModal(true)} title={'تعویضی ها'} />
          )}
        </div>
      </div>

      <ServiceDateSection lastVisit={lastVisit} />

      {showModal && <CarChangesModal setShowModal={setShowModal} carChanges={carChanges} />}
    </>
  )
}

export default memo(CarInfo)
